<template>
  <b-container>
    <div class="b-main-content">
      <h3>Machine View</h3>
      <br>
      Machine No : <b>{{ machine.machineID }}</b><br>
      Bales Produced : <b>{{ machine.numbales }}</b><br>
      Type : <b>{{ machine.type }}</b><br>
      Site : <b>{{ machine.siteID }}</b><br>
      Site Description : <b>{{ machine.description }}</b><br>
      GPS Position : <b>{{ machine.position }}</b><br>
      <br>
      <table id="customers">
        <tr>
          <th>Bale No.</th>
          <th>Date Produced</th>
          <th>Weight (Kg)</th>
        </tr>
        <template v-for="bale in bales">
          <tr :key="bale.BaleNo">
            <td>{{ bale.BaleNo }}</td>
            <td>{{ bale.Date }}</td>
            <td>{{ bale.Weight }}</td>
          </tr>
        </template>
      </table>
    </div>
  </b-container>
</template>

<script>
import { API } from 'aws-amplify'
import { mapState } from 'vuex'

export default {
    created: function () {
      //Fetch the data when the view is created and the data is already being observed
      this.fetchMachineData()
    },
    watch: {
      '$route': 'fetchMachineData'
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        })
    },
    data: function () {
        return {
            machine: {
              machineID: 'Loading...',
              siteID: '',
              description: "",
              position: 'x',
              numbales: 'x',
              type: ''
            },
            bales: [
            {
                "BaleNo": "Loading...",
                "Date": "",
                "Weight": ""
            }
            ]
        }
    },

    methods: {
      fetchMachineData: function() {
        console.log("getting data for machine = ", this.$route.path.replace("/machine/", ""))
        this.machine.machineID = this.$route.path.replace("/machine/", "")
        this.machine.siteID = "Loading..."
        this.machine.description = "x"
        this.machine.position = 'x'
        this.machine.numbales = 'x'

        this.bales.splice(1)
        this.$set(this.bales, 0, { "BaleNo": "Loading...", "Date": "", "Weight": ""})

        //now load data from API

//        API.get('balerapi', '/testbales', this.machine.machineID).then(response => {
//          const options = { headers: { Authorization: Auth.currentSession().idToken.jwtToken } }
          API.get('gbkpulseapi', '/getmachine', {'queryStringParameters': {'machine': [this.machine.machineID]}} ).then(response => {
          // Add your code here
          console.log("api response =", response)
          var body = JSON.parse(response.body)
          console.log("body =", body)
          console.log("machine =", body.machine)
          console.log("bales =", body.bale)

          for (var i = 0; i < body.bale.length; i++) {
            var newbale = []
            newbale.BaleNo = body.bale[i].baleNo
            newbale.Date = body.bale[i].date
            newbale.Weight = body.bale[i].weight

            this.$set(this.bales, i, newbale)
            console.log("i = ", i)
          }
          this.machine.description = body.machine.description
          this.machine.siteID = body.machine.siteID
          this.machine.position = body.machine.position
          this.machine.numbales = body.machine.bale
//           = notification
//           = machineID
//           = position
//           = siteID
//           = sitename
//           = time
          this.machine.type = body.machine.type

        }).catch(error => {
          console.log(error.response)
        })

//        this.$set(this.bales, 0, { "BaleNo": "5", "Date": "2018-11-07 17:12:00.123", "Weight": "51"})
//        this.$set(this.bales, 1, { "BaleNo": "4", "Date": "2018-11-06 17:12:00.123", "Weight": "47"})
//        this.$set(this.bales, 2, { "BaleNo": "3", "Date": "2018-11-05 17:12:00.123", "Weight": "45"})
//        this.$set(this.bales, 3, { "BaleNo": "2", "Date": "2018-11-04 17:12:00.123", "Weight": "54"})
//        this.$set(this.bales, 4, { "BaleNo": "1", "Date": "2018-11-03 17:12:00.123", "Weight": "34"})

      }
    }
    
}
</script>

<style scoped>
h3 {
  text-align: left;
  margin: 0px 8px 0px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#customers {
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

#customers td, #customers th {
    border: 1px solid #ddd;
    text-align: left;
    padding: 8px;
}



#customers tr:nth-child(even){background-color: #f2f2f2;}

#customers tr:hover {background-color: #ddd;}

#customers th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #4CAF50;
    color: white;
}


</style>
